import React from 'react';

// Transforme les URLs http(s) d'un texte en liens cliquables.
// Conserve les sauts de ligne via le style white-space:pre-wrap du conteneur parent.
export function linkify(text) {
  if (!text) return text;
  const parts = String(text).split(/(https?:\/\/[^\s]+)/g);
  return parts.map((part, i) => {
    if (/^https?:\/\//.test(part)) {
      return React.createElement('a', {
        key: i, href: part, target: '_blank', rel: 'noopener noreferrer',
        style: { color: '#8b1a2a', textDecoration: 'underline', wordBreak: 'break-all' }
      }, part);
    }
    return part;
  });
}
